import swal from "sweetalert2";

export const entityFound = async(field, itemsToRender, logger) => { 
	try {
		const result = await swal.fire({
			title: `Matching ${field.Name} found`,
			html:
				`An existing list item was found matching your entry: 
				<br/>
				<br/>${itemsToRender[0].data}${itemsToRender[1]?.hasData ? ` (${itemsToRender[1].data})` : ""}
				<br/>${itemsToRender[2]?.hasData ? `${itemsToRender[2].data}` : ""}. 
				<br/>
				<br/>
				Would you like to use it?`,
			showCloseButton: true,
			type: "info",
			showCancelButton: true,
			confirmButtonColor: "#8CC541",
			confirmButtonText: "Yes",
			cancelButtonText: "No",
			focusCancel: true,
			reverseButtons: true
		});

		return result;
	}
	catch(err) {
		logger.error(err);

		return { dismiss: swal.DismissReason.cancel };
	}
};